import { Modifier, EditorState, SelectionState } from 'draft-js';

/**
 * 删除 block
 * @param {Draft.ContentBlock} block
 * @param {DraftEditorStore} store
 */
export function removeBlock(store, block, removalDirection = 'forward') {
	const editorState = store.getEditorState();
	const content = editorState.getCurrentContent();
	const blockKey = block.getKey();
	const deleteRange = new SelectionState({
		anchorKey: blockKey,
		anchorOffset: 0,
		focusKey: blockKey,
		focusOffset: block.getLength() + 1,
	});
	const targetRange = new SelectionState({
		anchorKey: blockKey,
		anchorOffset: 0,
		focusKey: blockKey,
		focusOffset: 1,
	});
	store.setEditorState(
		EditorState.forceSelection(
			EditorState.push(
				editorState,
				Modifier.setBlockType(
					Modifier.removeRange(content, deleteRange, removalDirection),
					targetRange,
					'unstyled'
				),
				'remove-block'
			),
			targetRange
		)
	);
}



// WEBPACK FOOTER //
// ./lib/helpers/removeBlock.js